import { render, staticRenderFns } from "./AiSettings.vue?vue&type=template&id=70032c78&scoped=true&"
import script from "./AiSettings.vue?vue&type=script&lang=js&"
export * from "./AiSettings.vue?vue&type=script&lang=js&"
import style0 from "./AiSettings.vue?vue&type=style&index=0&id=70032c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70032c78",
  null
  
)

export default component.exports